import * as _ from 'underscore';

import { SiteSpaceRouterComponent } from '../../app/spaces/RouterHelpers/SiteSpaceRouter';
import { ServerSpaceRouterComponent } from '../../app/spaces/ServerSpaces/ServerSpaceRouter';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Module } from '../Module';
import { ServerService } from './ServerService';
import { SiteUrlNameCapturingRegex } from './SiteUrlMatcherFactory';

export class StartPageService {

  public static $inject = ['$location', 'ServerService'];

  constructor(
    private $location: ng.ILocationService,
    private server: ServerService,
  ) {}

  // Returns the default server start page when none has been set.
  public getServerDefaultStartPage(): string {
    return '/';
  }

  // Given a startPageUrl and a siteUrlName, returns the navigable start page. i.e.:
  //  1. If start page url is invalid, returns default start page for current site
  //  2. Prepends site prefix to the startPageUrl if site prefix is needed (not needed for default site
  //     urls and for non-site urls)
  public getStartPageForSite(startPageUrl: string, siteUrlName: string): string {
    const isValidUrl = this.isValidPath(startPageUrl);
    const isDefaultSite = !siteUrlName;
    if (!isValidUrl) {
      return this.getDefaultStartPageForSite(siteUrlName);
    } else if (this.isSitePath(startPageUrl) && !isDefaultSite) {
      return '/site/' + siteUrlName + startPageUrl;
    } else {
      return startPageUrl;
    }
  }

  public isValidPath(path: string): boolean {
    // the path being passed in doesn't include the /site/sitename prefix
    // so verify paths against urls without a site name.
    const urls = new SpacesSiteUrls({siteUrlName: ''});
    const sitePaths = SiteSpaceRouterComponent.getWatchedBasePaths(urls);
    const allBasePaths = sitePaths.concat(ServerSpaceRouterComponent.getWatchedBasePaths());
    return path !== '/' && _.some(allBasePaths, (basePath) => {
      return path.startsWith(basePath);
    });
  }

  public isSitePath(path: string): boolean {
    return this.isValidPath(path) && !path.startsWith('/server/');
  }

  // Gets a navigable start page url for the current user on the given site
  public getCurrentUserStartPageForSite(siteUrlName: string): string {
    return this.getStartPageForSite(this.server.getStartPage(), siteUrlName);
  }

  // Gets the navigable start page url for the current user on the current site
  public getCurrentUserStartPageForCurrentSite(): string {
    return this.getStartPageForSite(this.server.getStartPage(), this.server.sessionSiteUrlName());
  }

  // Get the current $location with the site prefix removed
  public getCurrentUrlAsStartPage(): string {
    return this.$location.url().replace(SiteUrlNameCapturingRegex, '');
  }

  private getDefaultStartPageForSite(siteUrlName: string): string {
    const siteUrls = new SpacesSiteUrls({ siteUrlName });
    return siteUrls.contentRootPath().replace(/^#/, '');
  }

}

Module.instance().service('StartPageService', StartPageService);
